(function () {
  var rootSelector = '#ymm-search-root';
  var mobileMediaQuery = '(max-width: 749px)';
  var rootWatcherFlag = '__ymmEmbedRootWatcherBound';
  var viewportWatcherFlag = '__ymmEmbedViewportWatcherBound';
  var controlIdCounter = 0;
  var pendingInit = false;

  function isMobileViewport() {
    return window.matchMedia && window.matchMedia(mobileMediaQuery).matches;
  }

  function nextFrame(callback) {
    if (window.requestAnimationFrame) {
      window.requestAnimationFrame(callback);
      return;
    }

    setTimeout(callback, 16);
  }

  function setCollapsedState(root, isCollapsed) {
    var label = root.querySelector('.vs-ymm-flat-label');

    root.classList.toggle('is-collapsed', isCollapsed);
    if (label) {
      label.setAttribute('aria-expanded', String(!isCollapsed));
    }
  }

  function syncClearState(root) {
    var clearButton = root.querySelector('#vs-clear-ymm');
    if (!clearButton) return;

    var inlineDisplay = clearButton.style && clearButton.style.display ? clearButton.style.display : '';
    var computedDisplay = window.getComputedStyle(clearButton).display;
    var isVisible = inlineDisplay ? inlineDisplay !== 'none' : computedDisplay !== 'none';

    clearButton.classList.toggle('ymm-clear-visible', isVisible);
    root.classList.toggle('ymm-has-clear', isVisible);
  }

  function syncDisabledState(root) {
    var wraps = root.querySelectorAll('.vs-ymm-flat-select-wrap');

    for (var i = 0; i < wraps.length; i += 1) {
      var wrap = wraps[i];
      var select = wrap.querySelector('select');
      var isDisabled =
        !!select &&
        (select.disabled || select.getAttribute('disabled') !== null || select.getAttribute('aria-disabled') === 'true');

      wrap.classList.toggle('is-disabled', isDisabled);
    }
  }

  function toggleCollapsed(root) {
    if (!isMobileViewport()) return;
    setCollapsedState(root, !root.classList.contains('is-collapsed'));
  }

  function clearDesktopCollapseState(root, label) {
    root.classList.remove('ymm-embed-collapsible');
    root.classList.remove('is-collapsed');
    delete root.dataset.ymmCollapseReady;

    if (label) {
      label.removeAttribute('role');
      label.removeAttribute('tabindex');
      label.removeAttribute('aria-controls');
      label.removeAttribute('aria-expanded');
    }
  }

  function bindRoot(root) {
    var label = root.querySelector('.vs-ymm-flat-label');
    var selects = root.querySelector('.vs-ymm-flat-selects');
    var searchButton = root.querySelector('#vs-search-btn');

    if (!label || !selects || !searchButton) return;

    if (!isMobileViewport()) {
      clearDesktopCollapseState(root, label);
      syncClearState(root);
      syncDisabledState(root);
      return;
    }

    root.classList.add('ymm-embed-collapsible');

    if (!selects.id) {
      controlIdCounter += 1;
      selects.id = 'vs-ymm-controls-' + controlIdCounter;
    }

    label.setAttribute('role', 'button');
    label.setAttribute('tabindex', '0');
    label.setAttribute('aria-controls', selects.id);

    if (!label.dataset.ymmCollapseBound) {
      label.addEventListener('click', function () {
        toggleCollapsed(root);
      });

      label.addEventListener('keydown', function (evt) {
        if (evt.key === 'Enter' || evt.key === ' ' || evt.key === 'Spacebar') {
          evt.preventDefault();
          toggleCollapsed(root);
        }
      });

      label.dataset.ymmCollapseBound = 'true';
    }

    if (!root.dataset.ymmCollapseReady) {
      setCollapsedState(root, true);
      root.dataset.ymmCollapseReady = 'true';
    }

    syncClearState(root);
    syncDisabledState(root);

    if (!root._ymmCollapseObserver) {
      root._ymmCollapseObserver = new MutationObserver(function (mutations) {
        var shouldRebind = false;
        var shouldSyncDisabled = false;

        for (var i = 0; i < mutations.length; i += 1) {
          var mutation = mutations[i];

          if (mutation.type === 'childList' && (mutation.addedNodes.length || mutation.removedNodes.length)) {
            shouldRebind = true;
            shouldSyncDisabled = true;
          }

          if (
            mutation.type === 'attributes' &&
            mutation.attributeName === 'style' &&
            mutation.target &&
            mutation.target.id === 'vs-clear-ymm'
          ) {
            syncClearState(root);
          }

          if (
            mutation.type === 'attributes' &&
            (mutation.attributeName === 'disabled' ||
              mutation.attributeName === 'aria-disabled') &&
            mutation.target &&
            mutation.target.tagName === 'SELECT'
          ) {
            shouldSyncDisabled = true;
          }
        }

        if (shouldRebind) {
          bindRoot(root);
          return;
        }

        if (shouldSyncDisabled) {
          syncDisabledState(root);
        }
      });

      root._ymmCollapseObserver.observe(root, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style', 'disabled', 'aria-disabled']
      });
    }
  }

  function initRoots() {
    var roots = document.querySelectorAll(rootSelector);
    for (var i = 0; i < roots.length; i += 1) {
      bindRoot(roots[i]);
    }
  }

  function scheduleInit() {
    if (pendingInit) return;

    pendingInit = true;
    nextFrame(function () {
      pendingInit = false;
      initRoots();
    });
  }

  function bindRootWatcher() {
    if (window[rootWatcherFlag] || !document.body) return;

    var rootWatcher = new MutationObserver(function () {
      scheduleInit();
    });

    rootWatcher.observe(document.body, {
      childList: true,
      subtree: true
    });

    window[rootWatcherFlag] = true;
  }

  function bindViewportWatcher() {
    if (window[viewportWatcherFlag]) return;

    window.addEventListener('resize', scheduleInit, { passive: true });
    window.addEventListener('orientationchange', scheduleInit);

    window[viewportWatcherFlag] = true;
  }

  function init() {
    initRoots();
    bindRootWatcher();
    bindViewportWatcher();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
